import React from 'react';

export default function Content() {
  return (
    <>
      <div className="s1_2_content">
        <div className="center pb-3">
          <p className="prt-bold fs-70 fc-black1 txt-left">2025 - 2021</p>
        </div>
        <div className="s1_2_mid_img w-100"></div>

        <div className="center pt-4  pb-5">
          <div className="row-flex align-start gap-50 mb-3 mt-3">
            <div className="year prt-semi-bold fs-24 fc-005eed lh-14 w-10">
              2025
            </div>
            <div className="history bd-bottom-de prt-regular fs-24 fc-555 pb-1 w-90 txt-left lh-14">
              매장 통합관리 솔루션 개발 및 도입
            </div>
          </div>

          <div className="row-flex align-start gap-50 mb-3 mt-3">
            <div className="year prt-semi-bold fs-24 fc-005eed lh-14 w-10">
              2024
            </div>
            <div className="history bd-bottom-de prt-regular fs-24 fc-555 pb-1 w-90 txt-left lh-14">
              크림봇 자체 브랜드 전국 판매지사 및 대리점 확대
              <br />
              산업용 청소로봇, 물류로봇 도입
            </div>
          </div>

          <div className="row-flex align-start gap-50 mb-3 mt-3">
            <div className="year prt-semi-bold fs-24 fc-005eed lh-14 w-10">
              2023
            </div>
            <div className="history bd-bottom-de prt-regular fs-24 fc-555 pb-1 w-90 txt-left lh-14 ">
              OEM 판매지사 전국 광역시별 7개 지점 전국 판매 개시
              <br />
              전국 영업 및 A/S망 구축시작
              <br />
              베어로보틱스, 비로보틱스 공식대리점 체결
              <br />
              호텔로봇 도입
              <br />
              테이블오더 샵체인 도입
            </div>
          </div>

          <div className="row-flex align-start gap-50 mb-3 mt-3">
            <div className="year prt-semi-bold fs-24 fc-005eed lh-14 w-10">
              2022
            </div>
            <div className="history bd-bottom-de prt-regular fs-24 fc-555 pb-1 w-90 txt-left lh-14">
              (주)크림봇 한국대리점 설립
              <br />
              OEM 총판을 통한 서울, 경기 지역 확장 판매 시작
              <br />
              키논로보틱스 공식대리점 체결
            </div>
          </div>

          <div className="row-flex align-start gap-50 mb-3 mt-3">
            <div className="year prt-semi-bold fs-24 fc-005eed lh-14 w-10">
              2021
            </div>
            <div className="history  prt-regular fs-24 fc-555 pb-1 w-90 txt-left lh-14">
              현대로보틱스 공식대리점 체결
              <br />
              서빙로봇 도입
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
